import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['forceFinderRefresh'] = false,
  action: Action,
): RootState['forceFinderRefresh'] {
  switch (action.type) {
    case 'FORCE_FINDER_REFRESH': {
      return action.payload
    }

    default:
      return state
  }
}
